import React, { useState, useEffect } from 'react';
import { makeStyles, withStyles } from "@material-ui/core/styles";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import {myGrid} from "assets/jss/material-dashboard-react.js";
import {
    myFormView
  } from "assets/jss/material-dashboard-react.js";
import { fontWeight } from '@mui/system';

const useStyles = makeStyles(theme => ({
    cardNome: {
        textAlign: "center",
        textTransform: "math-auto",
        fontWeight: 500,
    }
}));

const myGridStyle = makeStyles(myGrid);

 function GridProcessoSuspenssaoCassacao(props) {
  
    const classes = useStyles();
    const classesGrid = myGridStyle();

    
    
  return (
    <Card>
        <CardBody>
            <h6 className={classes.cardNome}>{props.title}</h6>
            {props.processos.map((processo, index) => {
                return (
                    <GridContainer style={myFormView.gridContainer} >
                        <GridItem xs={6} sm={6} md={6}>
                            <div className={classes.myBox}>
                                <div>{processo.Processo}</div>
                            </div>
                        </GridItem>
                        <GridItem xs={6} sm={6} md={6} >
                            <div className={classes.myBox}>
                                <div className={classes.myBoxValue + ' ' + classes.myBoxLabel}>{processo.Descricao}</div>
                            </div>
                        </GridItem>
                    </GridContainer>
                );
            })}
        </CardBody>
    </Card>
  );
}
export default GridProcessoSuspenssaoCassacao;
